const Styles = {
    'ResultsList': 'ResultsList_ResultsList--bc05c2f2'
};

export default Styles;